import { Box, Typography, Card, CardContent, Tooltip, Grid, Button, IconButton, Link } from '@mui/material'
import { CustomFileUploader } from 'shared/components/CustomFileUploader';
import { Layout } from 'shared/utils';
import { DeleteOutline, Info } from '@mui/icons-material';
import { HeaderTooltip } from './components/HeaderTooltip';
import { FileUploader } from 'react-drag-drop-files';
import { useUploadDocuments } from './hooks/useUploadDocuments';
import iconos from 'shared/assets';
import { Spinner } from 'shared';
import { SpinnerLoading } from 'shared/components/SpinnerLoading';
import DeleteIcon from '@mui/icons-material/Delete';
import style from './styles/uploadPayment.module.scss';

export const UploadPaymentSupports = () => {
  const { 
    errorSizeFile, errorTypeFile, handleChangeFileDocument, removeFileDocument, loadAsyncFiles, uploadXlsx, handleChangeFileXlsx, removeFileXlsx, cleanDocuments,
    document, isDisabled, fileLengthDocument, fileLength, typeAcceptedDocument, hasErrors, supports , typeAccept, originalName, loading, isLoading 
  } = useUploadDocuments();

  return (
    <Layout>
      <div>
        <Typography className='fs-6 fs-bold' variant='body2'>Carga masiva de información de pagos</Typography>
         <Card className={style.cardContainer}>
          <CardContent className={style.labelContent}>
            <Grid display={'flex'} alignItems={'center'} justifyContent={'space-between'} marginBottom={1}>
              <span>Cargar archivo excel: </span>
              <Tooltip title={ isDisabled ? <></> : <HeaderTooltip /> } hidden={isDisabled}>
                <Info fontSize='small' color="primary" data-testid={`tooltip_info`} />
              </Tooltip>
            </Grid>
            <CustomFileUploader 
              fileLength={fileLength}
              typeAccept={typeAccept}
              originalName={originalName}
              document={document}
              handleChangeFile={handleChangeFileXlsx}
              removeFile={removeFileXlsx}
              fullWidth={true}
              isDisabled={isDisabled}
              />
            <Grid container direction={"row"} justifyContent={'end'} marginTop={2}>
                <Button variant='contained' color='secondary' data-testid="btn-upload-xlx" onClick={uploadXlsx} disabled={isDisabled || !document}>
                    Cargar registros
                </Button>
            </Grid>
            
            {
               isDisabled && (
                <Box marginY={2}>
                  <span className='fs-bold'>Cargar documentos pdf correspondientes: </span>

                  <Grid container>
                    {
                      supports.map((doc) => (
                        
                        <Grid item xs={12} sm={6} md={6} lg={4}  className={style.containerSupports} key={doc.id}>
                          <Box display='flex' gap={1} alignItems='center' data-testid={`container_label_${doc.id}`}>
                            <Typography className={`${style.textLabel} ${doc.name.includes('(Obligatorio)') && 'text-required'}`} data-testid={`label_name_${doc.id}`}>{ doc.name }</Typography>
                          </Box>
                          <div className={style.divContentModal}>
                            <FileUploader
                              types={typeAcceptedDocument}
                              maxSize={fileLengthDocument}
                              handleChange={(e:any)=> handleChangeFileDocument(e, doc)}
                              hoverTitle={' '}
                              onTypeError={ errorTypeFile }
                              onSizeError={ errorSizeFile }
                              fileOrFiles={doc.file}
                              >
                              <Box className={style.contentFile} data-testid='btn_file_upload'>
                                <Box data-testid={`name-file-${doc.id}`} className={`${style.nameFile} ${hasErrors && doc.name.includes('(Obligatorio)') && style.errorFile}`}>
                                    { 
                                      doc.file ? <span>{doc.originalName}</span> 
                                      :( 
                                        <div className={style.contentDragDrop}>
                                            <img  src={iconos.iconoPDF} alt='iconoPDF'/>
                                            <div>Arrastrar el archivo a cargar </div>
                                          </div>
                                        )
                                    }
                                    <Box display='flex' gap={1}>
                                      {
                                        doc.file &&
                                        <Box className={style.contentFilesSelected}>
                                            <IconButton onClick={()=> removeFileDocument(doc)} data-testid={`file-remove-${doc.id}`}>
                                              <DeleteOutline/>
                                            </IconButton>
                                          </Box>
                                      }
                                      <Link className={style.fileDocument}><b> CARGAR</b></Link>
                                    </Box>
                                </Box>
                              </Box>
                              
                            </FileUploader>
                          </div>
                          <Box display='flex' justifyContent='space-between'>
                            <span className={style.spanError} data-testid={`message_error_${doc.id}`}>
                              { hasErrors && doc.name.includes('(Obligatorio)') && 'Campo obligatorio' }
                            </span>
                          </Box>
                        </Grid>
                      ))
                    }
                  </Grid>
                  <Grid container direction={"row"} justifyContent={'end'} marginTop={2} gap={1}>
                      <Tooltip title="Quitar documentos" placement="right" arrow>
                        <Button variant='contained' color='secondary' data-testid="clean-documents" onClick={cleanDocuments}><DeleteIcon fontSize='small'/></Button>
                      </Tooltip>
                      <Button variant='contained' color='secondary' className={'styles.buttonSubmit'} data-testid="btn-upload-documents" onClick={loadAsyncFiles}>
                          Cargar documentos
                      </Button>
                  </Grid>
                </Box>
              )
            }
          </CardContent>
          {(loading) && <Spinner/>}
          {(isLoading) && <SpinnerLoading/>}
        </Card>
      </div>
    </Layout>
  );
};

